import { FC } from 'react';
import { BaseAppCard } from './base-app-card';
import { useEnvironmentVariables } from '../../../../hooks/use-environment-variables';
import { ReactComponent as PipedriveLogo } from '../../../../../components/icons/pipedrive-logo.svg';

interface PipedriveAuthCardProps {
    isActive: boolean;
    isConnected: boolean;
    isLoading: boolean;
    onConnect: () => void;
    onDisconnect?: () => void;
}

export const PipedriveAuthCard: FC<PipedriveAuthCardProps> = ({
    isActive,
    isConnected,
    isLoading,
    onConnect,
    onDisconnect,
}) => {
    const { VITE_PIPEDRIVE_AUTHENTICATION_URI } = useEnvironmentVariables();

    const handleConnect = () => {
        window.open(VITE_PIPEDRIVE_AUTHENTICATION_URI, '_blank');
    };

    return (
        <BaseAppCard
            title="Pipedrive"
            showTitle={true}
            description="Sync Pipedrive with Andsend"
            appId="pipedrive"
            bgColor="bg-green-50"
            icon={<PipedriveLogo />}
            isConnected={isConnected}
            isActive={isActive}
            handleConnect={handleConnect}
            // onDisconnect={onDisconnect}
            isLoading={isLoading}
            connectButtonText="Connect Pipedrive"
            connectedText="Your Pipedrive account is connected."
            notConnectedText="Connect your Pipedrive account to sync contacts."
        />
    );
};
